import React, { useState, useEffect, lazy, Suspense } from "react";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";

// Lazy load CurrencyDialog to avoid circular dependency
const CurrencyDialog = lazy(() => import("./CurrencyDialog").then(module => ({ 
  default: module.CurrencyDialog 
})));

interface CurrencySelectorProps {
  value: any;
  onChange: (e: any) => void;
  className?: string;
  loading: boolean;
  currencies: Currency[];
  setCurrencies: (currency: Currency[]) => void;
}

interface Currency {
  id: number;
  code: string;
  name: string;
  symbol: string;
  label: string;
  value: number;
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  value,
  onChange,
  className = "",
  loading,
  currencies,
  setCurrencies
}) => {
  const localization = useSelector((state: any) => state.localization);

  const currencyTemplate = (option: any) => {
    return (
      <div className="flex items-center">
        <span className="mr-2">{option.symbol}</span>
        <span>{option.code} - {option.name}</span>
      </div>
    );
  };

  const selectedCurrencyTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="flex items-center">
          <span className="mr-2">{option.symbol}</span>
          <span>{option.code} - {option.name}</span>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  return (
    <div className="flex items-center">
      <Dropdown
        value={value}
        options={currencies}
        onChange={onChange}
        optionLabel="label"
        filter
        filterBy="code,name"
        placeholder={localization?.SelectCurrency || "Select a Currency"}
        className={`w-full ${className}`}
        loading={loading}
        itemTemplate={currencyTemplate}
        valueTemplate={selectedCurrencyTemplate}
      />
    </div>
  );
};